export default __webpack_public_path__ + "static/media/HeaderArbitrumLogoGoerli.c5d4dcab.png";